export default __webpack_public_path__ + "static/media/cameraOff.8db1adb2.svg";